module.exports = __webpack_public_path__ + "4336af55d94e01eef66d46b7db65dbad.png";